/**
 * Me → Couples sub-page (P1.6 — empty-state only; real data ships P2).
 */

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MeSubpageShell } from '../../components/chrome/MeSubpageShell';
import { EmptyState } from '../../components/me/EmptyState';

export function Couples(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation('me');
  return (
    <MeSubpageShell title={t('sections.couples')} data-testid="couples-page">
      <EmptyState
        title={t('couples.emptyTitle')}
        body={t('couples.emptyBody')}
        glyph="♡"
        ctaLabel={t('openHome')}
        onCta={() => void navigate('/home')}
        data-testid="couples-empty"
      />
    </MeSubpageShell>
  );
}
